module.exports = __webpack_public_path__ + "img/favicon.91f0d6ce.png";